import { styled } from '@fluentui/react';
import * as React from 'react';
import { getSubwayNavStyles } from './SubwayNav.styles';
import { ISubwayNavProps, ISubwayNavStyles } from './SubwayNav.types';
import { SubwayNavBase } from './SubwayNavBase';

export const SubwayNav: React.FunctionComponent<ISubwayNavProps> = styled<ISubwayNavProps, {}, ISubwayNavStyles>(
  SubwayNavBase,
  getSubwayNavStyles,
  undefined,
  { scope: 'SubwayNav' }
);
